// Constants
import { API } from './constants';

// Utils
import { apiFetch } from '../shared/utils/api';


class SettingsApi {
  static fetchFeedbackCategories(token) {
    const headers = { token };
    const requestOptions = { headers };

    return apiFetch(API.SETTINGS.FEEDBACK_CATEGORIES, requestOptions);
  }

  static sendFeedback(token, params) {
    const headers = { token };
    const body = { ...params };
    const requestOptions = { method: 'PUT', headers, body };

    return apiFetch(API.SETTINGS.FEEDBACK, requestOptions);
  }
}

export default SettingsApi;
